import React from 'react';
import { nullSafeGet } from '../../utils/DataAccessUtils';
import { HolderOutlined } from '@ant-design/icons';
import AccessPermissionChecker from '../common/AccessPermissionChecker';
import { PERMISSION_NAMES } from '../../utils/AuthUtils';

export default function ProblemTypeItemRow({ item, index, removeIcon = false }) {
	return (
		<div className=" draggable-item PrivateNetworkLocationsPage__secondaryEntity__list__item flex items-center justify-start">
			<div className="flex basis-2/4 items-center">
				<AccessPermissionChecker name={PERMISSION_NAMES.RANK_SUPPLIERS}>
					{!removeIcon && <HolderOutlined className="icon" translate={undefined} />}
				</AccessPermissionChecker>
				<div
					title={nullSafeGet('supplierFacility.displayName', item)}
					className=" PrivateNetworkLocationsPage__secondaryEntity__list__item__text text-ellipsis line-clamp-1"
				>
					{nullSafeGet('supplierFacility.displayName', item)}
				</div>
			</div>
			<div className="ml-16 basis-2/4 opacity-50">{`Rank ${index + 1}`}</div>
		</div>
	);
}
